import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extraccion',
  templateUrl: './extraccion.component.html',
  styleUrls: ['./extraccion.component.css']
})
export class ExtraccionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
